__turbopack_context__.v({
  "invalid": "textArea-module__L6HqWG__invalid",
  "resize-both": "textArea-module__L6HqWG__resize-both",
  "resize-horizontal": "textArea-module__L6HqWG__resize-horizontal",
  "resize-none": "textArea-module__L6HqWG__resize-none",
  "resize-vertical": "textArea-module__L6HqWG__resize-vertical",
  "size-lg": "textArea-module__L6HqWG__size-lg",
  "size-md": "textArea-module__L6HqWG__size-md",
  "size-sm": "textArea-module__L6HqWG__size-sm",
  "textarea": "textArea-module__L6HqWG__textarea",
});
